export default class HttpError extends Error {
  public status: number

  public statusText?: string

  public constructor(status: number, statusText?: string) {
    super(`HTTP Error ${status} ${statusText || ''}`)
    this.status = status
    this.statusText = statusText
  }

  public get name(): string {
    return this.constructor.name
  }
}
